/* eslint-disable jsx-a11y/anchor-is-valid */
// ============================================================
// หน้า Login — เข้าสู่ระบบ
// ------------------------------------------------------------
// หน้าที่ของไฟล์นี้: แสดงฟอร์ม + ตั้งค่า IP ของ server เท่านั้น
// ตรรกะการล็อกอิน/เก็บ session อยู่ที่ components/custom/auth.js
//
// เงื่อนไขตอนเข้าหน้านี้:
//   - ถ้าล็อกอินค้างไว้อยู่แล้ว (มี token + first_page) → เด้งเข้าระบบเลย
//       เลือกโครงการไว้แล้ว → ไปหน้า first_page | ยังไม่เลือก → ไปหน้าเลือกโครงการ
//   - ถ้าไม่มี → ล้าง session ที่ค้างอยู่ให้สะอาดก่อนล็อกอินใหม่
// ============================================================

import React, { Component } from "react";
import { Modal } from "react-bootstrap";

import LOGO from "../../assets/images/logo.png";
import "../../assets/css/bootstrap.css";
import { tokens, removeStorage, getStorage, loading, login } from "../../shared/index.js";

export default class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      show: true, // true = ซ่อนรหัสผ่าน (input type=password)
      modal_ip: false, // popup ตั้งค่า IP server
      ip_address: "",
    };
  }

  componentDidMount() {
    loading(false);
    const first_page = getStorage("first_page");
    const project_id = getStorage("project_id");
    if (tokens && first_page) {
      window.location.href = project_id ? first_page : "/choose-project";
    } else {
      removeStorage();
    }
  }

  // กดเข้าสู่ระบบ — สำเร็จแล้วไปหน้าเลือกโครงการเสมอ
  Login = async () => {
    loading(true);
    const result = await login(this.state.username, this.state.password);
    if (result) window.location.href = "/choose-project";
    loading(false);
  };

  // บันทึก/ล้างค่า IP ของ server (ใช้ตอนต้องชี้ไปเครื่องอื่นนอกเหนือจากค่าใน .env)
  saveIpAddress = (ip_address) => {
    localStorage.setItem("ip_address", ip_address);
    this.setState({ modal_ip: false, ip_address });
  };

  render() {
    return (
      <div className="w-100 position-relative">
        <div className="w-100 min-vh-100 d-flex align-items-center justify-content-center">
          <div className="col-10 col-sm-10 col-md-8 col-lg-6 col-xl-4 fade-in-slide-up">
            {/* โลโก้ */}
            <div className="w-100 text-center">
              <img className="mb-4 pointer" alt="logo" src={LOGO} style={{ width: "60%", maxWidth: 200 }} />
            </div>

            {/* กล่องฟอร์มล็อกอิน */}
            <div className="card border-0 shadow">
              <div className="col-12 p-4">
                <h4 className="mb-4">
                  <b>ลงชื่อเข้าใช้</b>
                </h4>

                {/* ชื่อผู้ใช้ — ใช้ onChange เพื่อให้รองรับการวาง (paste) ด้วย */}
                <input className="form-control mb-4 border-0 bg-contain" type="text" placeholder="Username/Email" onChange={(e) => this.setState({ username: e.target.value })} />

                {/* รหัสผ่าน + ปุ่มสลับซ่อน/แสดง — กด Enter = เข้าสู่ระบบ */}
                <div className="position-relative">
                  <input
                    className="form-control mb-4 border-0 bg-contain"
                    type={this.state.show ? "password" : "text"}
                    placeholder="รหัสผ่าน"
                    onChange={(e) => this.setState({ password: e.target.value })}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") this.Login();
                    }}
                  />
                  <label className="position-absolute icon pointer" style={{ right: 12, top: 8 }} onClick={() => this.setState({ show: !this.state.show })}>
                    {this.state.show ? "\uf070" : "\uf06e"}
                  </label>
                </div>

                <button type="button" className="btn btn-primary w-100" onClick={() => this.Login()}>
                  เข้าสู่ระบบ
                </button>

                {/* เวอร์ชัน + ลิขสิทธิ์ */}
                <div className="w-100 text-center mt-3">
                  {" "}
                  <small className="text-secondary">{process.env.REACT_APP_VERSION}</small> <br />
                  <small className="text-8">©copy right by c.d.s. service .co.,ltd and OMS service </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ปุ่มเฟืองมุมขวาบน — เปิดตั้งค่า IP */}
        <span
          className="position-absolute icon pointer"
          style={{ top: 12, right: 12 }}
          onClick={() => this.setState({ modal_ip: true, ip_address: localStorage.getItem("ip_address") || "" })}
        >
          {"\uf013"}
        </span>

        {/* popup ตั้งค่า IP ADDRESS */}
        <Modal show={this.state.modal_ip} onHide={() => this.setState({ modal_ip: false })}>
          <Modal.Header>
            <Modal.Title>
              <b>ตั้งค่า IP ADDRESS</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center  mb-3">
              <label className="wpx-140">IP address :</label>
              <input className="form-control border-0 bg-contain" type="text" placeholder="กรอกข้อมูล" onChange={(e) => this.setState({ ip_address: e.target.value })} value={this.state.ip_address} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_ip: false })}>
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-dark w-100" onClick={() => this.saveIpAddress("")}>
                  ล้างค่า
                </button>
              </div>
              <div className="w-50 p-1">
                <button className="btn btn-primary w-100" onClick={() => this.saveIpAddress(this.state.ip_address)}>
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
